export class TituloReceberIntegracaoImportFilter {
    idIntegracao: number;
    codigoIntegracao: string;
    numeroIntegracao: string;
    dataEmissaoInicial: Date;
    dataEmissaoFinal: Date;
    dataVencimentoInicial: Date;
    dataVencimentoFinal: Date;
}
